import api from '../../../api';
import { finish, error } from '../../../modules/roles/actions/create';
import { kebabCase } from 'lodash';

export function request(dispatch, { data }) {
    Object.assign(data, {
        extends: [],
        id: kebabCase(data.name)
    });

    api.put(`/roles/${kebabCase(data.name)}`, data).then(
        response => dispatch(finish(response)),
        ({ errors }) => dispatch(error(errors))
    );
}
